// Blog post publish dates. The DB stores a real timestamp (publish_at / created_at,
// surfaced as publishedAt) plus a free-text date_label that is usually only month + year
// ("July 2026"). Prefer the timestamp so every post shows the day it went live.

const displayFormat = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});

// Only accept ISO input. Date.parse is lenient enough to read "July 2026" as local
// midnight on the 1st, which then renders as a wrong (and timezone-shifted) exact day.
const ISO_DATE = /^\d{4}-\d{2}-\d{2}/;

const parse = (value?: string | null): Date | null => {
  if (!value || !ISO_DATE.test(value)) return null;
  const t = Date.parse(value);
  return Number.isNaN(t) ? null : new Date(t);
};

/** "26 July 2026", or the free-text label when no usable timestamp exists. */
export const formatPostDate = (publishedAt?: string | null, label?: string | null): string => {
  const date = parse(publishedAt);
  return date ? displayFormat.format(date) : (label ?? "");
};

/** "2026-07-26" for <time dateTime> and schema.org datePublished. Undefined when unknown. */
export const toIsoDate = (publishedAt?: string | null): string | undefined => {
  const date = parse(publishedAt);
  return date ? date.toISOString().slice(0, 10) : undefined;
};
